'use strict';
module.exports = require('./InputText.vue');